/** Generated by @jobilla/openapi-codegen. Do not edit manually. */

import { queryOptions, useQuery, useSuspenseQuery } from '@tanstack/react-query'
import type {
	UseQueryOptions,
	UseQueryResult,
	UseSuspenseQueryOptions,
	UseSuspenseQueryResult,
} from '@tanstack/react-query'
import type { AxiosError, AxiosRequestConfig } from 'axios'
import { profilesIndex } from '../../axios/profilesIndex'
import type { ProfilesIndexError, ProfilesIndexPathParams, ProfilesIndexResponse } from '../../types/ProfilesIndex'

export const profilesIndexQueryKey = (organisation: ProfilesIndexPathParams['organisation']) =>
	[{ url: '/:organisation/profiles', params: { organisation } }] as const

export type ProfilesIndexQueryKey = ReturnType<typeof profilesIndexQueryKey>

/** @see backend/nexus/modules/Billing/Http/Controllers/ProfilesController.php ProfilesController::index */
export function profilesIndexQueryOptions(
	organisation: ProfilesIndexPathParams['organisation'],
	config?: AxiosRequestConfig,
) {
	return queryOptions<
		ProfilesIndexResponse,
		AxiosError<ProfilesIndexError>,
		ProfilesIndexResponse,
		ProfilesIndexQueryKey
	>({
		queryKey: profilesIndexQueryKey(organisation),
		queryFn: ({ signal }) => profilesIndex(organisation, { signal, ...config }).then(res => res.data),
		enabled: !!organisation,
	})
}

/** @see backend/nexus/modules/Billing/Http/Controllers/ProfilesController.php ProfilesController::index */
export function useProfilesIndex<TSelectData = ProfilesIndexResponse>(
	organisation: ProfilesIndexPathParams['organisation'],
	options?:
		& Partial<
			Omit<
				UseQueryOptions<
					ProfilesIndexResponse,
					AxiosError<ProfilesIndexError>,
					TSelectData,
					ProfilesIndexQueryKey
				>,
				'queryKey' | 'queryFn'
			>
		>
		& { queryKey?: readonly unknown[] },
): UseQueryResult<TSelectData, AxiosError<ProfilesIndexError>> {
	const { queryKey: customQueryKey, ...opts } = options ?? {}
	return useQuery({
		...profilesIndexQueryOptions(organisation),
		...opts as any,
		...(customQueryKey ? { queryKey: customQueryKey as any } : {}),
	})
}

/** @see backend/nexus/modules/Billing/Http/Controllers/ProfilesController.php ProfilesController::index */
export function useProfilesIndexSuspense<TSelectData = ProfilesIndexResponse>(
	organisation: ProfilesIndexPathParams['organisation'],
	options?:
		& Partial<
			Omit<
				UseSuspenseQueryOptions<
					ProfilesIndexResponse,
					AxiosError<ProfilesIndexError>,
					TSelectData,
					ProfilesIndexQueryKey
				>,
				'queryKey' | 'queryFn'
			>
		>
		& { queryKey?: readonly unknown[] },
): UseSuspenseQueryResult<TSelectData, AxiosError<ProfilesIndexError>> {
	const { queryKey: customQueryKey, ...opts } = options ?? {}
	return useSuspenseQuery({
		...profilesIndexQueryOptions(organisation),
		...opts as any,
		...(customQueryKey ? { queryKey: customQueryKey as any } : {}),
	})
}
